
import TableList from "@components/templates/tablelist";
import { HttpReceiveList,HttpIsAcctive } from "@/service/bespeak";
import { mapState, mapGetters } from "vuex";
import comIndex from "./update.vue";
export default {
    mixins: [TableList],
    components:{
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpReceiveList,
        
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'addressreceiveUpdate',
                        params: { type: "add"},
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'addressreceiveUpdate',
                        params: { type: "edit"},
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "noactive":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "删除操作",
                        ajaxRequest:HttpIsAcctive
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        width:450,
                        showFooter: false,
                        data:{type:1},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/LogisticsAddress/batchImport",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/LogisticsAddress/addressTemplate', {}, 'download')
                        },
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/LogisticsAddress/batchExport', {...this.formData,type:1}, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show: true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: true,
                params:id,
                operate:'edit'
            },{
                label:'失效',
                show: true,
                params:id,
                operate:'noactive'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList', 'getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导入",
                    operate: "import",
                    theme: "success",
                },
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: '客户',
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    options:this.getNextOrgList,
                    show: true,
                },
                {
                    label: '目的地地址Code',
                    tag: 'vInput',
                    key: 'CN_addressCode',
                    show: true,
                },
                {
                    label: '状态',
                    tag: 'vSelect',
                    key: 'EQ_active',
                    options:[
                        {value:0,label:'启用'},
                        {value:1,label:'停用'}
                    ],
                    show: true,
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '客户',
                    key: 'orgId',
                    render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.orgId),
                },
                {
                    title: '状态',
                    render:(h,{row})=>{
                        return <div>{row.active == 0 ? '启用' : '停用'}</div>
                    }
                },
                {
                    title: '目的地地址Code',
                    key: 'addressCode',
                },
                {
                    title: '目的地地址',
                    key:'address',
                },
                {
                    title: '城市',
                    key:'city',
                },
                {
                    title: '州',
                    key:'state',
                },
                {
                    title: '国家',
                    key:'country',
                },
                {
                    title: '邮编',
                    key:'postal',
                },
                {
                    title: '收件人',
                    key:'linkman',
                },
                {
                    title: '联系电话',
                    key:'phone',
                },
                {
                    title: '创建人',
                    key:'createdName',
                },
                {
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
